import React from 'react';
import Layout from './Layout';
import { Card } from './ui/card';
import { CheckCircle } from 'lucide-react';

const TestDeploy = () => {
  return (
    <Layout title="Test Deploy">
      <Card className="p-8 text-center">
        <CheckCircle className="h-16 w-16 mx-auto text-green-500 mb-4" />
        <h1 className="text-3xl font-bold text-green-600 mb-2">
          ✅ DEPLOY FUNZIONANTE!
        </h1>
        <p className="text-xl text-gray-600 mb-4">
          Data: 18 Febbraio 2026 - Ore 14:15
        </p>
        <p className="text-gray-500">
          Se vedi questa pagina, il deploy ha incluso le ultime modifiche.
        </p>
        <div className="mt-6 p-4 bg-gray-100 rounded-lg">
          <p className="font-mono text-sm">
            DB_NAME atteso: smarthost-hub-test_database
          </p>
        </div>
      </Card>
    </Layout>
  );
};

export default TestDeploy;
